const API_BASE_URL = "https://api.backintheringapp.no";

export default API_BASE_URL;
